import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ConfigService } from './config.service';
import { TimeZone } from 'src/shared/models/time-zone.model';

@Injectable()
export class TimeZoneService {
    readonly apiServer: string;

    constructor(private _configService: ConfigService, private _http: HttpClient) { 
        this.apiServer = this._configService.appSettings.webApiServer + "api/TimeZones/";
    }

    async getSystemTimeZones(): Promise<TimeZone[]> {
        return await this._http.get<TimeZone[]>(`${this.apiServer}GetSystemTimeZones`).toPromise<TimeZone[]>();
    }

    async getUnitedStatesTimeZones(): Promise<TimeZone[]> {
        return await this._http.get<TimeZone[]>(`${this.apiServer}GetUnitedStatesTimeZones`).toPromise<TimeZone[]>();
    }
}